import { observer } from 'mobx-react-lite';

import { store } from 'store';

import { Modal } from '../Modal/Modal';

import * as S from './TransactionModal.styles';

const STATUS_ICON = {
  pending: '🔐',
  success: '✅',
  error: '❌',
} as const;

const STATUS_MESSAGE = {
  pending: 'Please confirm the transaction in your wallet...',
  success: 'Transaction completed successfully!',
  error: 'Transaction failed',
} as const;

export const TransactionModal = observer(() => {
  const { txModal, closeTxModal } = store.commonStore;

  if (!txModal) return null;

  const isFinished = txModal.status === 'success' || txModal.status === 'error';

  return (
    <Modal
      isOpen={!!txModal}
      onClose={isFinished ? closeTxModal : () => {}}
      maxWidth={380}
      title={txModal.title || 'Transaction'}
    >
      <S.Body>
        {txModal.status === 'pending' ? (
          <S.Spinner />
        ) : (
          <S.StatusIcon>{STATUS_ICON[txModal.status]}</S.StatusIcon>
        )}

        {txModal.title && <S.Title>{txModal.title}</S.Title>}

        <S.StatusText $status={txModal.status}>{STATUS_MESSAGE[txModal.status]}</S.StatusText>

        {isFinished && <S.CloseButton onClick={closeTxModal}>Close</S.CloseButton>}
      </S.Body>
    </Modal>
  );
});
